import { render, staticRenderFns } from "./KoioteNavigationProperties.vue?vue&type=template&id=4ab0f5b5"
import script from "./KoioteNavigationProperties.vue?vue&type=script&lang=js"
export * from "./KoioteNavigationProperties.vue?vue&type=script&lang=js"
import style0 from "./KoioteNavigationProperties.vue?vue&type=style&index=0&id=4ab0f5b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports